import { useMutation, useQuery } from "@tanstack/react-query";
import {
  lookupCustomerByEik,
  searchCustomers,
} from "../api/customers";

export const useCustomers = (q?: string, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["customers", q ?? ""],
    queryFn: () => searchCustomers(q),
    staleTime: 1000 * 60 * 5,
    enabled: options?.enabled ?? true,
  });
};

// Самостоятелна мутация — стартираме я на бутона „Извлечи" в модала.
// Не пишем към таблицата автоматично; FE решава дали да upsert-не след
// това с POST /customers.
export const useEikLookup = () => {
  return useMutation({
    mutationFn: (eik: string) => lookupCustomerByEik(eik),
  });
};

